import { render, staticRenderFns } from "./Newsroom2.vue?vue&type=template&id=8024e9f0&"
import script from "./Newsroom2.vue?vue&type=script&lang=js&"
export * from "./Newsroom2.vue?vue&type=script&lang=js&"
import style0 from "./Newsroom2.vue?vue&type=style&index=0&lang=scss&scopeed=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports